export class WebToolItem {
  name = '';
  description = '';
  homeUrl = '';
  imageSource = '';
  expired = false;
  licensed = false;
  showLearnMore = false;

  constructor(item: {
    description: string;
    expired: boolean;
    homeUrl: string;
    imageSource: string;
    licensed: boolean;
    name: string;
  }) {
    this.name = item.name.replace(/^ALK /, '').replace(/^CoPilot /, '');
    this.description = item.description;
    this.homeUrl = item.homeUrl;
    this.imageSource = `/assets/img/${item.imageSource}`;
    this.expired = item.expired;
    this.licensed = item.licensed;
  }
}
